import request from '@/utils/request'

// 提交模型
export function submitModel(data) {
  return request({ url: '/api/v1/submit', method: 'post', data })
}

// GitHub OAuth 登录
export function login(params) {
  return request({ url: '/api/v1/login', method: 'get', params })
}

// 获取用户信息
export function getUserProfile(params) {
  return request({ url: '/api/v1/user/profile', method: 'get', params })
}

// 获取模型列表
export function getModels(params) {
  return request({ url: '/api/v1/models', method: 'get', params })
}

// 获取模型分数详情
export function getModelScoreDetail(id) {
  return request({ url: `/api/v1/models/score/detail/${id}`, method: 'get' })
}

// 获取赛季分数
export function getSeasonScore({ season, season_month, season_week }) {
  return request({ url: `/api/v1/season/score/${season}/${season_month}/${season_week}`, method: 'get' })
}

// 获取任务到数据集的映射
export function getTask2Dataset(data) {
  return request({ url: '/api/v1/models/task2dataset', method: 'post', data })
}

// 获取赛季列表
export function getSeasonList() {
  return request({ url: '/api/v1/season', method: 'get' })
}

// 获取用户模型列表
export function getProfileModels() {
  return request({ url: '/api/v1/profile/model', method: 'get' })
}

// 删除用户模型
export function deleteProfileModel(id) {
  return request({ url: `/api/v1/profile/model/${id}`, method: 'delete' })
}
